export const variantExpand = (variantId, title, url, price, variantOptionsString) => ({
	variantId,
	title,
	url,
	price,
	variantOptionsString,
	isActive: false,

	handleClick(event) {
		if (event.pointerType === 'mouse') return

		if (event.pointerType === 'touch' && !this.isActive) {
			this.isActive = true
		}
	},

	async add() {
		this.$store.cart.add(
			this.variantId,
			this.title,
			this.price,
			1,
			this.url,
			this.variantOptionsString
		)

		setTimeout(() => {
			this.$store.cart.getCart()
			this.isActive = false
		}, 500)
	},
});
